function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M5.087 5.401l-1.732.134c-.483.037-.912.29-1.178.693L.178 9.251a1.066 1.066 0 0 0-.086 1.023c.149.336.453.57.816.626l1.586.245c.371-1.97 1.26-3.934 2.593-5.744z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M8.855 17.506l.245 1.586a1.066 1.066 0 0 0 1.06.908c.206 0 .41-.06.59-.178l3.022-1.999c.403-.266.656-.696.693-1.178l.134-1.733c-1.81 1.334-3.775 2.223-5.744 2.594z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M8.258 16.406a1 1 0 0 0 .166-.014 11.48 11.48 0 0 0 2.379-.674l-6.52-6.52a11.481 11.481 0 0 0-.675 2.378c-.055.325.054.657.287.89l3.639 3.638c.193.194.455.302.724.302z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M18.405 8.867c-1.061 2.053-3.399 4.744-6.47 6.332a.597.597 0 0 0-.048-.055l-7.031-7.03a.608.608 0 0 0-.055-.048c1.588-3.072 4.28-5.41 6.332-6.471C13.715.259 16.42 0 18.13 0c.332 0 .628.01.876.023.524.029.942.447.97.97.084 1.53.025 4.79-1.57 7.874zM11.63 4.228A2.91 2.91 0 0 0 10.77 6.3c0 .782.304 1.518.858 2.071a2.92 2.92 0 0 0 2.071.857c.75 0 1.5-.286 2.072-.857A2.91 2.91 0 0 0 16.63 6.3a2.91 2.91 0 0 0-.858-2.072 2.933 2.933 0 0 0-4.143 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M12.457 7.543A1.76 1.76 0 0 0 15.458 6.3 1.752 1.752 0 0 0 13.7 4.543c-.45 0-.9.171-1.243.514a1.746 1.746 0 0 0-.515 1.243c0 .47.183.91.515 1.243z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M.598 16.482c.15 0 .3-.057.414-.172l1.913-1.913a.586.586 0 1 0-.829-.828L.183 15.482a.586.586 0 0 0 .415 1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M4.678 15.322a.586.586 0 0 0-.828 0L.172 19a.586.586 0 0 0 .828.828l3.678-3.678a.586.586 0 0 0 0-.828z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M5.603 17.075L3.69 18.988a.586.586 0 0 0 .828.828l1.913-1.913a.586.586 0 0 0-.828-.828z"
})))));

var SvgIconCaseStarted = function SvgIconCaseStarted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCaseStarted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-case-started.24528595.svg";
export { ForwardRef as ReactComponent };